module.exports = __webpack_public_path__ + "assets/img/tel_all.dd38b28d.png";